module.exports = __webpack_public_path__ + "img/w3_grid_light.4d978403.png";